'use strict';

var $ = require('jquery');
var colorbox = require('../lib/plaudit.colorbox.js');
var lightboxDefaultOptions = require('./siteLightboxOptions.js');

function closeColorbox() {
	$.colorbox.close();
}
function lightboxMessage() {
	var $elem = $('#lightboxMessage');
	if ($elem.length == 0) {
		return;
	}

	var options = $.extend({}, lightboxDefaultOptions, {
		speed: 450,
		width: 800,
		maxWidth: '90%',
		maxHeight: '90%',
		inline: true,
		opacity: .5,
		href: $elem,
		open: true,
		onComplete: function(){
			$(window).on('resize', closeColorbox);
		},
		onClosed: function(){
			$(window).off('resize', closeColorbox);
		}
	});

	$elem.colorbox(options);
}


module.exports = {
	init: function(){
		lightboxMessage();
	}
}